import { createTheme } from '@mui/material/styles';

export const createPreviewTheme = (width: number) =>
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: width < 600 ? 99999 : 600,
        md: width < 900 ? 99999 : 900,
        lg: width < 1200 ? 99999 : 1200,
        xl: width < 1536 ? 99999 : 1536,
      },
    },
    components: {
      MuiUseMediaQuery: {
        defaultProps: {
          // This works in browser too — overrides the matchMedia implementation
          matchMedia: (query: string) => {
            const fakeWidth = width;
            // Replace viewport width queries with our fake width
            const modifiedQuery = query
              .replace(
                /\(min-width:\s*(\d+(?:\.\d+)?)(px|em|rem)\)/g,
                (_, value, unit) => {
                  const px =
                    unit === 'px' ? parseFloat(value) : parseFloat(value) * 16;
                  return `(min-width: ${px <= fakeWidth ? '0px' : '99999px'})`;
                },
              )
              .replace(
                /\(max-width:\s*(\d+(?:\.\d+)?)(px|em|rem)\)/g,
                (_, value, unit) => {
                  const px =
                    unit === 'px' ? parseFloat(value) : parseFloat(value) * 16;
                  return `(max-width: ${px >= fakeWidth ? '99999px' : '0px'})`;
                },
              );
            return window.matchMedia(modifiedQuery);
          },
        },
      },
    },
  });
